import React from 'react';

import { FormComponent } from 'components';
import { SearchFeedbackFilterType } from 'types';

interface Props {
  filter: SearchFeedbackFilterType;
  handleFilter: (filter: SearchFeedbackFilterType) => void;
}

function Filter({ handleFilter }: Props) {
  return (
    <FormComponent.Form submit={handleFilter}>
      <FormComponent.SearchInput
        name="title"
        placeholder="타이틀로 검색해주세요"
      />
    </FormComponent.Form>
  );
}

export default Filter;
